export default __webpack_public_path__ + "static/media/55.9f5c1730.jpeg";